import { createSlice } from "@reduxjs/toolkit";
import { LogState } from "./types";

const initialState: LogState = { log_list: null, log_count: [] };

const logsSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    logsList: (state, action) => {
      state.log_list = action.payload;
    },
    logsCount: (state, action) => {
      state.log_count = action.payload;
    },
  },
});

export const { logsList, logsCount } = logsSlice.actions;
export default logsSlice.reducer;
